import { Component, Inject, OnInit, OnDestroy, output, input } from '@angular/core';
import { Subscription } from 'rxjs';

import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MyStoriesService } from '../../modules/stories/services/my-stories.service';
import { CommonModalServiceService } from '../../services/common-modal-service.service';
import { TranslationService } from '../../services/translation.service';

@Component({
    selector: 'app-common-modal',
    templateUrl: './common-modal.component.html',
    styleUrls: ['./common-modal.component.scss'],
    imports: [CommonModule, TranslateModule],
    standalone: true,
})
export class CommonModalComponent implements OnInit, OnDestroy {
    headerTitle: string | undefined = 'Add';
    isCloseButtonClicked: boolean = false;
    isSaveButtonClicked: boolean = false;
    isCloseButtonVisible: boolean = false;
    isSaveButtonVisible: boolean = false;

    readonly isCloseModal = input<boolean>(null as any);

    readonly closeButtonTitle = input<any>('');

    readonly saveButtonTitle = input<any>('');

    readonly showModalContent = input<any>('');

    readonly doneButtonDisabled = input<any>(null as any);

    readonly templateBtn = input<boolean | undefined>(true);

    readonly component = input<string>(null as any);

    readonly isHeaderVisible = input<boolean>(null as any);

    readonly closeModalEmitter = output<boolean>();

    readonly saveModalEmitter = output<boolean>();

    readonly type = input<any>(null as any);

    readonly isFooterVisible = input<any>(null as any);
    translationData: any = [];
    public showSpinner: boolean = false;
    private spinnerSubscription!: Subscription;

    subscription: Subscription = new Subscription();
    isErrorOccured: boolean = false;

    constructor(
        @Inject(CommonModalServiceService)
        private readonly commonModalService: CommonModalServiceService,
        public readonly translationService: TranslationService,
        private readonly myStoriesService: MyStoriesService,
    ) {}

    ngOnInit(): void {
        const subscription1 = this.commonModalService._modalHeaderTitle.subscribe((data) => {
            this.headerTitle = data;
        });

        const subscription2 = this.commonModalService._modalHeaderIsCloseBtnVisible.subscribe(
            (data) => {
                this.isCloseButtonVisible = data;
            },
        );

        const subscription3 = this.commonModalService._modalHeaderIsSaveBtnVisible.subscribe(
            (data) => {
                this.isSaveButtonVisible = data;
            },
        );

        this.subscription.add(subscription1);
        this.subscription.add(subscription2);
        this.subscription.add(subscription3);
        this.spinnerSubscription = this.myStoriesService.showSpinnerSubject$.subscribe(
            (state: boolean) => {
                this.showSpinner = state;
            },
        );
    }

    close() {
        this.closeModalEmitter.emit(true);
    }

    save() {
        this.myStoriesService.showSpinner(); // Show spinner initially
        if (this.headerTitle === 'CP_LM_MAINPAGE_MYPROFILE') {
            if (this.isErrorOccured) {
                this.myStoriesService.hideSpinner(); // Hide spinner if an error occurred
            }
        }
        this.saveModalEmitter.emit(true);
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
